module.exports = __webpack_public_path__ + "static/media/TRX.3ae08da4.svg";